const argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", nullTag = "[object Null]", numberTag = "[object Number]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
const arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", int8Tag = "[object Int8Array]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint8Tag = "[object Uint8Array]";
const isStrNum = (val) => isString(val) || isNumber(val);
const isJsonString = (text) => {
  if (typeof text !== "string")
    return false;
  try {
    JSON.parse(text);
    return true;
  } catch (error) {
    return false;
  }
};
const parseJson = (string, defaultValue = null) => {
  try {
    const parsed = JSON.parse(string);
    return parsed;
  } catch (e) {
    console.error("Can not parse JSON value\n", e);
    return defaultValue;
  }
};
const stringifyJson = (json) => JSON.stringify(json);
const deepEqual = (a, b) => {
  if (a === b)
    return true;
  if (typeof a === "function" && b.toString)
    return a.toString() === b.toString();
  if (a && b && typeof a === "object" && typeof b === "object") {
    if (a.constructor !== b.constructor)
      return false;
    if (Array.isArray(a)) {
      if (a.length !== b.length)
        return false;
      for (let i = a.length - 1; i >= 0; i--)
        if (!deepEqual(a[i], b[i]))
          return false;
      return true;
    }
    if (a instanceof Map && b instanceof Map) {
      if (a.size !== b.size)
        return false;
      for (const i of a.entries())
        if (!b.has(i[0]))
          return false;
      for (const i of a.entries())
        if (!deepEqual(i[1], b.get(i[0])))
          return false;
      return true;
    }
    if (a instanceof Set && b instanceof Set) {
      if (a.size !== b.size)
        return false;
      for (const i of a.entries())
        if (!b.has(i[0]))
          return false;
      return true;
    }
    if (a.constructor === RegExp && b.constructor === RegExp)
      return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf || b.valueOf !== Object.prototype.valueOf)
      return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString || b.toString !== Object.prototype.toString)
      return a.toString() === b.toString();
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length)
      return false;
    for (let i = keys.length - 1; i >= 0; i--)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i]))
        return false;
    for (let i = keys.length - 1; i >= 0; i--) {
      const key = keys[i];
      if (key === "_owner" && a.$$typeof) {
        continue;
      }
      if (!deepEqual(a[key], b[key]))
        return false;
    }
    return true;
  }
  return false;
};
const getTag = (value) => {
  if (value == null)
    return value === void 0 ? undefinedTag : nullTag;
  return toString.call(value);
};
const isObjectLike = (value) => typeof value === "object" && value !== null;
const isPlainObject = (value) => {
  if (!isObjectLike(value) || getTag(value) != objectTag)
    return false;
  if (Object.getPrototypeOf(value) === null)
    return true;
  let proto = value;
  while (Object.getPrototypeOf(proto) !== null)
    proto = Object.getPrototypeOf(proto);
  return Object.getPrototypeOf(value) === proto;
};
const isArray = (value) => Array.isArray(value);
const isNumber = (value) => (typeof value === "number" || isObjectLike(value) && getTag(value) == numberTag) && !Number.isNaN(value) && value !== Number.POSITIVE_INFINITY && value !== Number.NEGATIVE_INFINITY;
const isString = (value) => {
  const type = typeof value;
  return type === "string" || type === "object" && value != null && !Array.isArray(value) && getTag(value) == stringTag;
};
const isRegExp = (value) => isObjectLike(value) && getTag(value) == regexpTag;
const isUndefined = (value) => value === void 0;
const isFunction = (value) => typeof value === "function";
const isNil = (value) => value === null || value === void 0;
const isEmpty = (value) => {
  if (isArray(value) || isString(value))
    return !value.length;
  if (isPlainObject(value))
    return !Object.keys(value).length;
  return true;
};
const multiplePathArgs = (args) => isArray(args) && args.every(isString) && args.length ? args : isString(args) ? [args] : null;
export {
  argsTag,
  arrayBufferTag,
  arrayTag,
  asyncTag,
  boolTag,
  dataViewTag,
  dateTag,
  deepEqual,
  domExcTag,
  errorTag,
  float32Tag,
  float64Tag,
  funcTag,
  genTag,
  getTag,
  int16Tag,
  int32Tag,
  int8Tag,
  isArray,
  isEmpty,
  isFunction,
  isJsonString,
  isNil,
  isNumber,
  isObjectLike,
  isPlainObject,
  isRegExp,
  isStrNum,
  isString,
  isUndefined,
  mapTag,
  multiplePathArgs,
  nullTag,
  numberTag,
  objectTag,
  parseJson,
  promiseTag,
  proxyTag,
  regexpTag,
  setTag,
  stringTag,
  stringifyJson,
  symbolTag,
  uint16Tag,
  uint32Tag,
  uint8ClampedTag,
  uint8Tag,
  undefinedTag,
  weakMapTag,
  weakSetTag
};
//# sourceMappingURL=lodash.js.map
